import React, { useState } from 'react';
import Axios from 'axios';

const Login = ({ setAuth }) => {
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const url = isRegister ? "register" : "login";
    try {
      const res = await Axios.post(`http://localhost:3001/api/${url}`, { email, password });
      if (!isRegister) {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("userId", res.data.user.id);
        setAuth(true);
      } else {
        alert("Success! Access granted.");
        setIsRegister(false);
      }
    } catch (err) {
      alert("Verification failed: " + (err.response?.data || "Server error"));
    }
  };

  return (
    <div style={containerStyle}>
      <div style={loginCard}>
        {/* Sleek Minimal Branding */}
        <div style={headerSection}>
          <div style={logoIcon}>B</div>
          <h1 style={titleStyle}>BAYTASOFT <span style={lightText}>CRM</span></h1>
        </div>

        <form onSubmit={handleSubmit} style={formStyle}>
          <div style={inputGroup}>
            <label style={labelStyle}>AUTHORIZED EMAIL</label>
            <input 
              type="email" 
              placeholder="user@admin.com" 
              style={inputStyle} 
              onChange={(e) => setEmail(e.target.value)} 
              required
            />
          </div>

          <div style={inputGroup}>
            <label style={labelStyle}>SECURE PASSWORD</label>
            <input 
              type="password" 
              placeholder="••••••••" 
              style={inputStyle} 
              onChange={(e) => setPassword(e.target.value)} 
              required
            />
          </div>

          <button type="submit" style={primaryBtn}>
            {isRegister ? "CREATE ACCOUNT" : "AUTHENTICATE"}
          </button>
        </form>

        <div style={footerStyle}>
          <p style={{ margin: 0 }}>
            {isRegister ? "Already registered?" : "New system user?"}
            <span onClick={() => setIsRegister(!isRegister)} style={linkStyle}>
              {isRegister ? " SIGN IN" : " REQUEST ACCESS"}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

// --- CARBON TECH STYLES ---

const containerStyle = {
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#2e0000', // Pure deep neutral
  fontFamily: "'Inter', sans-serif"
};

const loginCard = {
  width: '400px',
  padding: '48px',
  backgroundColor: '#3b0000', // Slate gray
  border: '1px solid #bebebe',
  borderRadius: '4px', // Sharp professional corners
  boxShadow: '0 20px 40px rgba(0,0,0,0.4)'
};

const headerSection = {
  textAlign: 'center',
  marginBottom: '40px'
};

const logoIcon = {
  width: '40px',
  height: '40px',
  backgroundColor: '#fff',
  color: '#000',
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: '900',
  fontSize: '20px',
  marginBottom: '15px',
  borderRadius: '2px'
};

const titleStyle = {
  color: '#fff',
  fontSize: '18px',
  margin: 0,
  letterSpacing: '4px',
  fontWeight: '700'
};

const lightText = {
  fontWeight: '300',
  color: '#888'
};

const formStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px'
};

const inputGroup = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px'
};

const labelStyle = {
  fontSize: '10px',
  color: '#666',
  letterSpacing: '1.5px',
  fontWeight: '600'
};

const inputStyle = {
  padding: '14px',
  backgroundColor: '#c3d2f0',
  border: '1px solid #333',
  color: '#fff',
  borderRadius: '4px',
  outline: 'none',
  fontSize: '14px',
  transition: 'border-color 0.3s'
};

const primaryBtn = {
  padding: '16px',
  backgroundColor: '#ff8c00',
  color: '#000000',
  border: 'none',
  fontWeight: '700',
  fontSize: '12px',
  letterSpacing: '2px',
  cursor: 'pointer',
  marginTop: '10px',
  borderRadius: '2px',
  transition: 'opacity 0.2s'
};

const footerStyle = {
  marginTop: '32px',
  textAlign: 'center',
  fontSize: '11px',
  color: '#555'
};

const linkStyle = {
  color: '#fff',
  cursor: 'pointer',
  marginLeft: '5px',
  fontWeight: '700'
};

export default Login;